import React from 'react';
import {Box, Breadcrumbs} from '@mui/material';
import BreadCrumb from '@/ui/bread-crumb/BreadCrumb';
import ContentTitles from '@/ui/content-titles/content-titles';
import PointsList from '@/ui/points-list/points-list';
import ContactSnippet from '@/ui/contact-snippet/contact-snippet';
import ContentArticleReader from '@/ui/content-article-reader/content-article-reader';
import ImageGallery from 'react-image-gallery';
import _ from 'lodash';
import {getAllUnRelatedSubCategoriesByCategory, getRelatedSubCategoriesByCategory} from '@/lib';
import {SubCategory} from '@/types';
import {BUSINESS_NAME} from "@/content";
import ServiceSEO from "@/lib/seo/service-seo";
import ServicesPanel from "@/ui/services-panel/services-panel";
import {useResizeHook} from "@/lib";


const ServiceSubCategoryPage = ({subCategory}: { subCategory: SubCategory }) => {

    const {title, description, headCategory, slug} = subCategory

    const {lessThanTablet} = useResizeHook();


    const relatedServices = getRelatedSubCategoriesByCategory(subCategory)
    const unRelatedServices = getAllUnRelatedSubCategoriesByCategory(subCategory)


    const disableSwipe = lessThanTablet;


    return (
        <>
            <ServiceSEO service={subCategory}/>
            <div className='w-full'>

                <Box sx={{
                    margin: 'auto',
                    pb: 4,
                    position: 'relative',
                }}>
                    <Breadcrumbs
                        sx={(theme) => ({
                            width: '100%',
                            '&.MuiBreadcrumbs-root': {
                                pt: .5,
                                pb: 0,
                                backgroundColor: theme.palette.background.paper,
                                width: '100%',
                                '& a': {
                                    fontSize: '14px',
                                },
                                '& li >p': {
                                    fontSize: '14px',
                                }
                            }
                        })}
                    >
                        <BreadCrumb
                            title={title}
                            slug={slug}
                            categoryTitle={_.capitalize(headCategory.categoryType)}
                            categoryRoute={`${headCategory.categoryType}`}
                            headCategoryTitle={`${headCategory.name}`}
                            headCategoryRoute={`${headCategory.categoryType}/${headCategory.slug}`}

                        />
                    </Breadcrumbs>

                    <Box
                        sx={(theme) => ({
                            margin: 'auto',
                            pt: 5,
                            pb: 3,
                            px: 6,
                            display: 'grid',
                            gridTemplateColumns: '1fr 387px',
                            gap: 5,
                            [theme.breakpoints.down('lg')]: {
                                gridTemplateColumns: '1fr 270px',
                                px: 3,
                            },
                            [theme.breakpoints.down('md')]: {
                                px: 1,
                                gridTemplateColumns: '1fr',
                            }
                        })}
                    >
                        <Box>

                            <ContentTitles
                                title={title}
                                subTitle={description}
                                titleComponent='h1'
                                subTitleComponent='h2'
                            />

                            <Box
                                sx={() => ({
                                    mx: 'auto',
                                })}>

                                <Box sx={(theme) => ({
                                    textAlign: 'center',
                                    pb: 5,
                                    backgroundColor: theme.palette.background.paper,
                                    borderTop: `1px solid ${theme.palette.primary.dark}`,
                                })}>
                                    <Box sx={(theme) => ({
                                        alignItems: 'center',
                                        display: 'flex',
                                        gap: '10px',
                                        flexDirection: 'row',
                                        [theme.breakpoints.down('lg')]: {
                                            flexDirection: 'column',
                                        }
                                    })}>
                                        <Box
                                            sx={{
                                                '.image-gallery-slide-wrapper': {
                                                    pointerEvents: disableSwipe ? 'none' : 'inherit',
                                                }
                                            }}
                                        >
                                            {
                                                (subCategory?.images?.length > 2 && !lessThanTablet) ?
                                                    <ImageGallery
                                                        items={subCategory.images ?? []}
                                                        showThumbnails={true}
                                                        thumbnailPosition='bottom'
                                                        showBullets={true}
                                                        showNav={false}
                                                        showPlayButton={false}
                                                        showFullscreenButton={false}
                                                        disableSwipe={true}
                                                        autoPlay={true}
                                                    />
                                                    :
                                                    subCategory?.images?.[0]?.original ?
                                                        <img src={subCategory.images[0].original} height='auto'
                                                             width='100%' alt={subCategory.images[0].originalAlt}/>
                                                        : <div></div>
                                            }

                                        </Box>
                                        <Box>
                                            <PointsList points={subCategory.points}/>
                                        </Box>
                                    </Box>
                                </Box>
                                <ContentArticleReader contentBlocks={subCategory.content ?? []}/>
                            </Box>
                        </Box>
                        <Box sx={(theme) => ({
                            [theme.breakpoints.down('lg')]: {
                                gridTemplateColumns: '1fr',
                            },
                        })}>
                            <Box>
                                <ServicesPanel services={relatedServices}
                                               title='Related Services'
                                               subTitle='Other services we offer that may interest you'
                                />
                            </Box>
                            <Box pt={2}>
                                <ServicesPanel services={unRelatedServices}
                                               title='Other Services'
                                               subTitle='Browse through our other services'
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </div>
            <ContactSnippet title={`Contact ${BUSINESS_NAME}`}
                            contactButtonText='Email us for any enquiries'
                            showContactButton
                            showContactInformation
            />
        </>
    )
};

export default ServiceSubCategoryPage;
